// import Style from '../../../../../component/popup/style.module.css'
import * as yup from 'yup'
import { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import { useApiCall } from '../../../../component/custom-hooks/api-call'
import "react-datepicker/dist/react-datepicker.css";
import { Alert, Snackbar } from '@mui/material'
import { FormArea, FeildWraper, SelectSearch, FeildError, FormLabel, FileUploadProgressBar } from '../../../../component/form/form-layout'
import moment from 'moment'

const AddRepairPopup = ({ onClose = () => { }, onError = () => { }, onSubmit = () => { }, currentData, dropdowns, Style }) => {
    const apiCall = useApiCall();
    const [alertData, setAlertData] = useState({ isShow: false });

    useEffect(() => {
        console.log("currentData", currentData)
        if (currentData?.id) {
            formik.setFieldValue("assetName", currentData?.asset_name || "")
            formik.setFieldValue("category", currentData?.category_id ? Number(currentData?.category_id) : "")
            formik.setFieldValue("location_id", currentData?.location_id || "")
            formik.setFieldValue("vendor_id", currentData?.vendor_id || "")
            formik.setFieldValue("assetCode", currentData?.asset_code || "")
            formik.setFieldValue("brand", currentData?.brand || "")
            formik.setFieldValue("model", currentData?.model || "")
            formik.setFieldValue("purchase_date", currentData?.purchase_date ? moment(currentData?.purchase_date, "DD-MMM-YYYY").format("YYYY-MM-DD") : "")
            formik.setFieldValue("warranty_end", currentData?.warranty_end ? moment(currentData?.warranty_end, "DD-MMM-YYYY").format("YYYY-MM-DD") : "")
            formik.setFieldValue("condition", currentData?.condition || "")
        }
    }, [currentData?.id])

    const handleClose = () => {
        setAlertData({ isShow: false })
    }

    function capitalize(word = "") {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }

    const validationSchema = yup.object().shape({
        asset: yup.string().required('This Field is required'),
        issue: yup.string().required('This Field is required'),
        reportedDate: yup.string().required('This Field is required'),
    });

    const formik = useFormik({
        initialValues: {
            // assetName: "",
            // category: "",
            // location_id: "",
            // vendor_id: "",
            // assetCode: "",
            // brand: "",
            // model: "",
            // purchase_date: "",
            // warranty_end: "",
            // condition: ""
            asset: "",
            issue: "",
            reportedDate: "",
            description: ""
        },
        enableReinitialize: true,
        validationSchema,
        onSubmit: async (values) => {
            console.log("Values", values);
            let extraData = {}
            if (currentData?.id) {
                extraData = {
                    "id": currentData?.id
                }
            }
            const apiData = JSON.stringify({
                ...extraData,
                "asset_id"  : values?.asset,
                "issue_type"    : values?.issue,
                "description"   : values?.description,
                "reported_date"  : values?.reportedDate
            });

            try {
                const resp = await apiCall({ method: "post", url: currentData?.id ? `office-asset/update` : `office-asset/repairs/add`, data: apiData });
                onSubmit(resp?.message || `Request Submitted`);
                formik.resetForm();
            } catch (error) {
                onError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
            }
        }
    });

    return (
        <>
            <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
                <div className={Style.modal_body}>
                    <FormArea>
                        <FeildWraper>
                            <FormLabel required>Asset</FormLabel>

                            <SelectSearch
                                name="asset"
                                placeholder="- Select Asset -"
                                onChange={(val) => {
                                    formik.setFieldValue("asset", val);
                                }}
                                value={formik.values.asset}
                                options={dropdowns?.asset_list?.map((el) => ({
                                    label: `${el.value} (${el?.code})`,
                                    value: el.id,
                                }))}
                            />
                            {formik.touched.asset && formik.errors.asset && (
                                <FeildError>{formik.errors.asset}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Issue Type</FormLabel>

                            <SelectSearch
                                name="issue"
                                placeholder="- Select Issue -"
                                onChange={(val) => {
                                    formik.setFieldValue("issue", val);
                                }}
                                value={formik.values.issue}
                                options={dropdowns?.repairt_issue_type?.map((el) => ({
                                    label: capitalize(el),
                                    value: el,
                                }))}
                            />
                            {formik.touched.issue && formik.errors.issue && (
                                <FeildError>{formik.errors.issue}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Reported Date</FormLabel>
                            <input
                                type={'date'}
                                name={'reportedDate'}
                                onChange={formik.handleChange}
                                value={formik.values.reportedDate}
                                max={moment(new Date()).format("YYYY-MM-DD")}
                                placeholder='Reported Date'
                            />
                            {formik.touched.reportedDate && formik.errors.reportedDate && (
                                <FeildError>{formik.errors.reportedDate}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel>Description</FormLabel>
                            <input
                                type={'text'}
                                name={'description'}
                                onChange={formik.handleChange}
                                value={formik.values.description}
                                placeholder='Description'
                            />
                            {formik.touched.description && formik.errors.description && (
                                <FeildError>{formik.errors.description}</FeildError>
                            )}
                        </FeildWraper>

                    </FormArea>
                </div>

                <div className={Style.modal_foot}>
                    {
                        (formik?.values?.assignTo || (currentData?.id && currentData?.status == "Assigned" && formik?.values?.status != "Assigned")) ?
                            <p className='text-red-500 text-[14px]'>{formik?.values?.assignTo ? "If you enter an Assign to Date, the asset remains in stock, it gets assigned and then immediately unassigned from the selected user." : "This action will unassign all users from the asset."}</p>
                            :
                            null
                    }
                    {/* <div className={`${Style.dcmb__cardFoot}`}> */}
                        <button type='reset' className={`${Style.dcmb__cancel}`} onClick={() => onClose()}>Discard</button>
                        <button type='submit' className={`${Style.dcmb__submit}`}>Apply</button>
                    {/* </div> */}
                </div>
            </form>

            <Snackbar open={alertData?.isShow} autoHideDuration={3000} onClose={handleClose}>
                <Alert
                    onClose={handleClose}
                    severity={alertData?.type}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {alertData?.message}
                </Alert>
            </Snackbar>
        </>
    )
}

export default AddRepairPopup
